/* eslint-disable react/display-name */
import React, { Fragment, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { fetchTooltipData } from '@actions/tooltips-actions';
import ActivityLogTooltip from '@components/activity-logs/tooltips';
import WorkflowIcon from '@icons/workflow-icon';
import DefaultDate from '@shared/formatted-date-helper';
import './tooltip.scss';

const CycleTooltip = ({ children, id, text }) => {
  const dispatch = useDispatch();
  const data = useSelector(state => state.tooltips.cycle[id]);
  const error = useSelector(state => state.tooltips.error.cycle?.[id]);

  const handleFetch = useCallback(() => {
    dispatch(fetchTooltipData('cycle', null, id));
  }, [dispatch, id]);

  const handleLinkClick = useCallback(() => {
    window.open(`/cycle/${id}`, '_blank');
  }, [id]);

  const renderTitle = useCallback(() => (
    <Fragment>
      <div styleName="body-title-icon">
        <WorkflowIcon />
      </div>
      <div styleName="body-title-text">
        {data?.workflow_name}
      </div>
    </Fragment>
  ), [data]);

  const renderContent = useCallback(() => (
    <div styleName="body-content">
      <div styleName="body-row body-item">
        {data?.name}
      </div>
      <div styleName="body-row">
        <div styleName="body-row-item">
          {data?.task_count}&nbsp;Tasks
        </div>
        <div styleName="body-row-bullet">&bull;</div>
        <div styleName="body-row-item">
          <DefaultDate value={data?.created} />
        </div>
      </div>
    </div>
  ), [data]);

  return (
    <ActivityLogTooltip
      data={data}
      error={error}
      onFetch={handleFetch}
      renderTitle={renderTitle}
      renderContent={renderContent}
      linkLabel="VIEW WORKFLOW"
      onLinkClick={handleLinkClick}
      dataType="cycle"
    >
      {children || text}
    </ActivityLogTooltip>
  );
};

CycleTooltip.propTypes = {
  children: PropTypes.node,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  text: PropTypes.string
};

export default CycleTooltip;
